export default __webpack_public_path__ + "static/media/facebookHover.6b8627c8.svg";